"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const table_schema_provider_1 = require("@8base-react/table-schema-provider");
const utils_1 = require("@8base/utils");
const RecordCrud_1 = require("./RecordCrud");
/**
 * Component for creating the record of the table
 *
 * @prop {string} tableName - Name of the table
 * @prop {string} tableId - Id of the table
 * @prop {(Function, ChildrenPropObject) => React.ReactNode} children - Render prop with result of the queries
 */
class RecordCreate extends react_1.Component {
    constructor() {
        super(...arguments);
        this.renderQuery = ({ tableSchema, loading }) => {
            const _a = this.props, { children } = _a, rest = __rest(_a, ["children"]);
            if (!tableSchema && !loading) {
                throw new utils_1.SDKError(utils_1.ERROR_CODES.TABLE_NOT_FOUND, utils_1.PACKAGES.CRUD, `Table doesn't find`);
            }
            if (!tableSchema) {
                return null;
            }
            return (react_1.default.createElement(RecordCrud_1.RecordCrud, Object.assign({}, rest, { tableSchema: tableSchema, mode: "create", includeColumns: this.props.includeColumns }), (mutateFunction, mutateResult) => children(mutateFunction, {
                mutateResult,
                tableSchema,
            })));
        };
    }
    render() {
        const { tableId } = this.props;
        return react_1.default.createElement(table_schema_provider_1.TableConsumer, { id: tableId }, this.renderQuery);
    }
}
exports.RecordCreate = RecordCreate;
//# sourceMappingURL=RecordCreate.js.map